import React from "react";
import { Link } from "react-router-dom";

const Menus = () => {
  return (
    <>
    <div className="d-flex align-items-center justify-content-evenly">
    <ul className="">

      <li>
        <Link to="/">Home</Link>
      </li>
      <li className="has-dropdown " >
        <Link to="">Features</Link>
        <ul className="submenu ">
        <li>
            <Link to="/network" className="">network Membership Management</Link>
          </li>
          <li>
            <Link to="/event ">Event Website & Registration</Link>
          </li>

          <li>
            <Link to="/one2One">One2One Meeting Scheduling</Link>
          </li>
          <li>
            <Link to="/eventManagement">Event Management</Link>
          </li>
        </ul>
      </li>
      <li className="">
        <Link to="/Solutions">Solutions</Link>


      </li>
      <li className="has-dropdown " >
        <Link to="/Resources">Resources</Link>
        <ul className="submenu ">
          <li>
            <Link to="/Price" className="">Price</Link>
          </li>
          <li>
            <Link to="/Support" className="">Support</Link>
          </li>
          <li>
            <Link to="/About_Us ">About Us</Link>
          </li>


        </ul>
      </li>
      <li>
            <Link to="/Contact_Us">Contact Us</Link>
          </li>
    </ul>
     <button>
     <Link to="/Demo" className="butn-1 rounded-pill border-2 border border-black hover-bg-black ms-5 ">Request Demo</Link>
   </button>
   </div>
  </>
  );
};

export default Menus;
